import React, { Component } from 'react'

class BreadTop extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      image: 'images/sandwich-parts/bread-top/' + props.image + '.svg',
      name: props.name
    };
  }

  render() {
    return (
      <img src={this.state.image} alt={this.state.name} />
    );
  }
}

export default BreadTop



// WEBPACK FOOTER //
// ./src/scripts/components/BreadTop.js